module.exports = __webpack_public_path__ + "img/logo.b31c7cc0.svg";